import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetData,
  type GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetError,
  type GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetResponse,
  getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGet,
} from '../../generated';

export type GetCollectionQueryVariables =
  GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetData['path'];

export type GetCollectionQuery = GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetResponse;

export const useGetCollectionQuery = <
  TData = GetCollectionQuery,
  TError = GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetError,
>(
  { portfolio_id, collection_id }: GetCollectionQueryVariables,
  options?: Omit<UseQueryOptions<GetCollectionQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<GetCollectionQuery, TError, TData>({
    queryKey: ['GetCollection', { portfolio_id, collection_id }],
    queryFn: async () => {
      const { data } = await getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGet({
        path: { portfolio_id, collection_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useGetCollectionQuery.getKey = ({ portfolio_id, collection_id }: GetCollectionQueryVariables) => [
  'GetCollection',
  { portfolio_id, collection_id },
];

useGetCollectionQuery.fetcher = (
  { portfolio_id, collection_id }: GetCollectionQueryVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGet({
      path: { portfolio_id, collection_id },
      throwOnError: true,
    });
    return data;
  };
};
